// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Jges","header":"ReportDetails_header__2v-yJ","title":"ReportDetails_title__2vS9R","left":"ReportDetails_left__1Qj95"};